<template>
  <div :class="$style['compare-tool']">
    <div :class="$style['marginB']">
      <h3>{{ pageHeadingInfo.heading }}</h3>
      <div :class="$style['cf-supportingText_CashFlow']">
        {{ pageHeadingInfo.subHeading }}
      </div>
    </div>

    <div class="right-body-container right-body-white-container" ref="root">
      <chart-selection
        :chartTabContent="chartTabContent"
        @onSelectedTab="onSelectedTab"
      >
        <template v-slot:right-side-section>
          <adl-input-format
            :label="'Projection Year'"
            :class="$style['projectionPosition']"
            size="small"
            :value="0"
            v-model="projectionYear.Value"
            appendText=""
            :maxlength="3"
            :maxvalue="projectionYear.Maxvalue"
            :isAllowOnlyNumber="true"
            :isAllowOnlyInteger="true"
            currencyFormat=""
            :isError="projectionYear.IsError"
            :errorText="projectionYear.ErrorText"
            @change="changeProjectionYear($event)"
            @submit="submitProjectionYear($event)"
          ></adl-input-format>

          <span
            :class="
              compareGraphOption.length <= 0
                ? $style['popoverButon']
                : $style['popoverButonSecond']
            "
            v-if="compareGraphOwners.length == 1"
          >
            {{ compareGraphOwner.text }}
          </span>
          <mds-button
            v-if="compareGraphOwners.length > 1"
            type="button"
            id="with-title-trigger-second"
            :class="
              compareGraphOption.length <= 0
                ? $style['popoverButon']
                : $style['popoverButonSecond']
            "
            icon-right="caret-down"
            @click="ownerPopToggle = !ownerPopToggle"
            >{{ compareGraphOwner.text }}
          </mds-button>
          <mds-popover
            v-if="compareGraphOwners.length > 1"
            width="200px"
            triggered-by="with-title-trigger-second"
            v-model="ownerPopToggle"
            :position="['bottom-center', 'right-center', 'top-center']"
          >
            <mds-list-group size="small">
              <mds-list-group-item
                :key="option.id"
                v-for="option in compareGraphOwners"
                @click.native="userSelectedOwner(option)"
              >
                {{ option.text }}</mds-list-group-item
              >
            </mds-list-group>
          </mds-popover>
          <mds-button
            v-if="compareGraphOption.length > 0"
            type="button"
            id="with-title-trigger"
            :class="$style['popoverButon']"
            icon-right="caret-down"
            @click="toggle = !toggle"
            >{{ compareGraphProp }}</mds-button
          >
          <mds-popover
            v-if="compareGraphOption.length > 0"
            width="200px"
            triggered-by="with-title-trigger"
            v-model="toggle"
            :position="['bottom-center', 'right-center', 'top-center']"
          >
            <mds-list-group size="small">
              <mds-list-group-item
                :key="option.id"
                v-for="option in compareGraphOption"
                @click.native="userSelectedOption(option)"
              >
                {{ option.name }}</mds-list-group-item
              >
            </mds-list-group>
          </mds-popover>
        </template>
        <template v-slot:tabBody>
          <component
            :is="selectedComponent"
            :chartProperties="chartProperties"
            :chartData="chartData"
            :tooltipHeader="tooltipHeader"
            :tooltipData="tooltipData"
            :tooltipDataProp="tooltipDataProp"
            v-if="chartData.length > 0"
          ></component>
        </template>
      </chart-selection>
    </div>

    <adl-compare-table
      :headers="headers"
      :rowsdata="rowsdata"
      :groupedRows="groupedRows"
      :mainHeading="mainHeading"
    />
    <template>
      <page-footer>
        <template #action-button-left>
          <mds-button
            size="large"
            variation="flat"
            icon="caret-left"
            @click="onBackButtonClick"
          >
            Back
          </mds-button>
        </template>
        <template #action-button-right>
          <mds-button
            type="button"
            @click="onBackButtonClick"
            variation="secondary"
          >
            Cancel
          </mds-button>
          <mds-button type="button" @click="submit" variation="primary">
            Done
          </mds-button>
        </template>
      </page-footer>
    </template>
  </div>
</template>
<script>
import { ChartSelection } from "../tool";
import ChartBarGroup from "./chart-bar-group.vue";
import ChartLineGroup from "./chart-line-group.vue";
import { PageFooter } from "../../component";
import { MdsButton } from "@mds/button";
import MdsPopover from "@mds/popover";
import { MdsListGroup, MdsListGroupItem } from "@mds/list-group";
import AdlCompareTable from "../custom/ComparisonTable/ComparisonTable.vue";
import AdlInputFormat from "../custom/input-format/InputFormat.vue";
export default {
  components: {
    ChartSelection,
    ChartBarGroup,
    PageFooter,
    MdsButton,
    MdsListGroup,
    MdsListGroupItem,
    MdsPopover,
    AdlCompareTable,
    AdlInputFormat,
    ChartLineGroup,
  },
  props: {
    pageHeadingInfo: {
      type: Object,
    },
    chartTabContent: {
      type: Array,
    },
    chartProperties: {
      type: Object,
    },
    tooltipDataProp: {
      type: Array,
    },
    chartData: {
      type: Array,
    },
    tooltipData: {
      type: Array,
    },
    compareGraphProp: {
      type: String,
    },
    compareGraphOption: {
      type: Array,
    },
    compareGraphOwner: {
      type: Object,
    },
    compareGraphOwners: {
      type: Array,
    },
    tooltipHeader: {
      type: Array,
    },
    selectedComponent: {
      type: String,
    },

    headers: Array,
    rowsdata: Object,
    groupedRows: Array,
    open: {
      type: Boolean,
      default: false,
    },
    projectionYear: {
      type: Object,
    },
    mainHeading: String,
  },

  data() {
    return {
      toggle: false,
      ownerPopToggle: false,
    };
  },

  beforeDestroy() {},
  methods: {
    submitProjectionYear() {
      this.$emit("submit", {});
    },
    userSelectedOption(option) {
      this.$emit("changeGraphPropOption", option);
      this.toggle = false;
    },
    userSelectedOwner(option) {
      this.$emit("changeGraphOwnerOption", option);
      this.ownerPopToggle = false;
    },
    changeProjectionYear(data) {
      this.$emit("changeProjectionYear", data);
    },
    onBackButtonClick() {
      this.$emit("onBack", {});
    },
    cancelButtonClick() {
      this.$emit("cancelInstance", {});
    },
    submit() {
      this.$emit("onBack", {});
    },
    getScreenWidth() {
      let rootElement = this.$refs.root;
      if (rootElement !== undefined) {
        let rootWidth = Number(rootElement.clientWidth) || this.rootWidth;
        if (rootWidth % 2 != 0) {
          return rootWidth - 1;
        }
        return rootWidth;
      }
      return 0;
    },
    onSelectedTab(tabId) {
      this.$emit("onChangeChartTab", tabId);
    },
  },
};
</script>
<style lang="scss" module>
.compare-tool {
  .projectionPosition {
    position: absolute;
    top: -7px;
    right: 0;
    width: 110px;
    .mds-input__field-error-wrapper {
      position: absolute;
      right: 0;
    }
  }
  .marginB {
    margin-bottom: 20px;
  }

  .popoverButon {
    margin-right: 130px;
    position: relative;
    top: 1px;
  }

  .popoverButonSecond {
    margin-right: 10px;
    position: relative;
    top: 1px;
  }
  .marginL {
    position: relative;
    top: -8px;
    padding-right: -8px;
  }
}
</style>
